import React, { useState, useEffect, memo, useMemo } from 'react';
import Header from '../layout/Header';
import { connect } from 'react-redux';
import { GENCREST_COLUMNS } from './transactionsList/column';
import Paginated from './transactionsList/Paginated';
import { getDate, selectValueGetter } from '../../utils/helper';
import { Link } from 'react-router-dom';
import { importIcon } from '../../Image/Index';
import { getDynamicdata } from './campaigns/services';
import { ValidatorForm } from 'react-form-validator-core';
import SelectValidator from '../partial/SelectValidator';
import { getAllTrasaction } from '../../actions/auth';
import { decrypt } from '../../utils/encodingdecoding';
import moment from 'moment';

const GencrestTransactionsList = memo(
    () => {
        const [data, setData] = useState([]);
        const [transactionCount, setTransactionCount] = useState();
        const [loader, setLoader] = useState(true);
        const [schemaData, setSchemaData] = useState([]);
        const [transaction, setTransaction] = useState([])
        let id = decrypt(localStorage.getItem('Id'));

        const onSubmit = () => { };
        useEffect(() => {
            let tempPageIndex = JSON.parse(
                localStorage.getItem('TransPageIndex'),
            );
            if (tempPageIndex === 1) {
                fetch();
            }
            // eslint-disable-next-line
        }, []);

        useEffect(() => {
            const ShortData = () => {
                const tempData = transaction?.data || [];

                if (!Array.isArray(tempData)) {
                    setData([]);
                    return;
                }

                const formatted = tempData
                    .map((item) => {
                        const req = item?.requestData;

                        if (!req?.customer) return null;

                        return {
                            firstName: req?.customer?.name || "-",
                            mobile: req?.customer?.mobile || "-",
                            totalAmount: req?.payment?.totalAmount || "-",
                            transactionDate: req?.transactionDate
                                ? moment(req.transactionDate).format("DD-MMM-YYYY")
                                : "-",
                            upiId: req?.payment?.upiId || "-",
                            upiName: req?.payment?.upiName || "-",
                            bankName: req?.payment?.bankName || "-",
                            accountNumber: req?.payment?.accountNumber || "-",
                            ifscCode: req?.payment?.ifscCode || "-",
                            beneficiaryName: req?.payment?.beneficiaryName || "-",
                            action: (
                                <Link
                                    to={`/customer-view/${req?.customer?.customerCode}`}
                                    state={{
                                        customerCode: req?.customer?.customerCode,
                                    }}
                                    className='edit_btn'
                                >
                                    <i className='fa-solid fa-eye'></i>
                                    View Details
                                </Link>
                            ),
                        };
                    })
                    .filter(Boolean);

                setData(formatted?.reverse());
            };

            ShortData();
        }, [transaction]);

        const fetch = async () => {
            setLoader(true);
            const token = JSON.parse(localStorage.getItem('token_gen'));
            let id = localStorage.getItem('Id');
            const res = await getDynamicdata(token?.access_token, "", "")
            setTransaction(res)
            setLoader(false);
        }

        const generateCSV = () => {
            try {
                if (!data || data.length === 0) {
                    alert("No data available to download!");
                    return;
                }

                const downloadColumns = GENCREST_COLUMNS.filter(
                    (col) => col.accessor !== "action"
                );

                const headers = downloadColumns.map((col) => col.Header);

                const rows = data.map((item) =>
                    downloadColumns.map((col) => {
                        const value = item[col.accessor];

                        if (value === null || value === undefined) return "";
                        return value.toString().replace(/,/g, " ");
                    })
                );

                const csvContent = [headers, ...rows]
                    .map((row) => row.join(","))
                    .join("\n");

                const encodedUri = encodeURI(
                    "data:text/csv;charset=utf-8," + csvContent
                );

                const link = document.createElement("a");
                link.setAttribute("href", encodedUri);
                link.setAttribute("download", "transactions.csv");
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            } catch (error) {
                console.error("CSV Download Error:", error);
                alert("Failed to generate CSV");
            }
        };

        useEffect(() => {
            setTransactionCount(transaction?.totalCount);
        }, [transaction]);

        return (
            <>
                <Header
                    name={'Transaction'}
                />
                {loader && (
                    <div className='mainPreloaderMain'>
                        <div className='mainPreloader'>
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                        </div>
                    </div>
                )}
                <div className='dashboard__content'>
                    <div className='container-fluid'>
                        <div className='dashboard__transactionsCard'>
                            <div className='dashboard__header'>
                                <div className='dashboard__left'>
                                    <h4>Transaction Data</h4>
                                </div>
                                <div className='dashboard__right'>
                                    <Link
                                        to={`/uploading-existing-datas?type=transaction`}
                                        id='upload_transction'
                                        state={{
                                            prevPath: '/transactions-list',
                                            from: 'transaction',
                                        }}
                                        className='btn btn-default'>
                                        <img
                                            src={importIcon}
                                            alt=''
                                        />{' '}
                                        Upload Transaction
                                    </Link>
                                </div>
                            </div>
                            <div className='dashboard__body'>
                                <p>No existing transaction data.</p>
                                <p>
                                    You can add data by uploading a CSV file
                                    containing the details.{' '}
                                </p>
                            </div>
                        </div>
                        <div className='dashboard__transactionsCard'>
                            <div className='dashboard__header'>
                                <div className='dashboard__left'>
                                    <h4 id='transction_list'>
                                        All Transactions
                                    </h4>
                                </div>
                                <div className='dashboard__right'>
                                    <button
                                        onClick={generateCSV}
                                        className='btn btn-default'>
                                        <i
                                            class='fa-solid fa-download'
                                            style={{ marginRight: '10px' }}></i>
                                        Download Transaction
                                    </button>
                                </div>
                            </div>
                            <div className='dashboard__body'>
                                <Paginated
                                    data={data}
                                    columns={GENCREST_COLUMNS}
                                    setLoader={setLoader}
                                    loader={loader}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    },
);


export default GencrestTransactionsList
